





































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { ApiResponse } from '@/components/types';
import SalutationSelect from '@/modules/conservatorship/components/SalutationSelect.vue';
import { ChangePositionToConservator, Employee } from '@/modules/employee/types';
import { CHANGE_POSITION_TO_CONSERVATOR } from '@/modules/employee/store';

const Employee = namespace('employee');

@Component({
  components: {
    SalutationSelect
  }
})
export default class ChangePositionToConservatorDialog extends Vue {
  @Prop() value!: Employee | null;

  @Employee.Action(CHANGE_POSITION_TO_CONSERVATOR) changePosition!: (command: ChangePositionToConservator) => Promise<ApiResponse>;

  error: any = null;
  dialog: boolean = false;

  employee: ChangePositionToConservator = {
    employee_id: '',
    hourly_rate: 0
  };

  @Watch('dialog')
  watchDialogClosed(dialog: boolean) {
    if (dialog) return;

    setTimeout(() => {
      this.employee = {
        employee_id: '',
        hourly_rate: 0
      };

      this.error = null;
      this.$emit('input', null);
      // @ts-ignore
      this.$refs.form.reset();
    }, 200);
  }

  @Watch('value')
  watchTermSet(employee: Employee) {
    if (!employee) return;

    this.init();

    setTimeout(() => {
      this.dialog = true;
    }, 200);
  }

  init() {
    if (!this.value) return;

    this.employee.employee_id = this.value.id;
  }

  async save(): Promise<ApiResponse> {
    this.error = null;

    return this.changePosition(this.employee);
  }
}
